export default "__VITE_ASSET__BdzxkbGG__"